import React from "react";
import classNames from "classnames";
import styles from "./FixDropdownOption.module.scss";
import { Icon } from "@/elements-react/fix-icon";

export interface FixDropdownOptionItem {
  label: string;
  value: string | number;
  icon?: React.ReactNode;
  selected: boolean;
}

interface FixDropdownOptionProps {
  label: string;
  value: string | number;
  selected?: boolean;
  icon?: React.ReactNode;
  onClick?: (value: string | number) => void;
}

const FixDropdownOption: React.FC<FixDropdownOptionProps> = ({ label, value, selected = false, icon, onClick }) => {
  return (
    <div
      className={classNames(styles.fixDropdownOption, { [styles.selected]: selected })}
      tabIndex={0}
      role="option"
      aria-selected={selected}
      onClick={onClick ? () => onClick(value) : undefined}
    >
      {icon}
      <span className={styles.label}>{label ?? value}</span>
      {selected && (
        <div className={styles.fixDropdownOptionSelectedIcon}>
          <Icon name="check" />
        </div>
      )}
    </div>
  );
};

export default FixDropdownOption;
